require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = 628
// module chunks = 29